import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Feedback = ApplicationRecord.extend({
  attrs: {
    delivery: belongsTo({ type: 'deliveries-deliveries', persist: false }),
    delivery_id: attr({ type: Number }),
    recipe_id: attr({ type: Number }),
    component_ids: attr(),
    product_ids: attr(),
    customer_id: attr({ type: Number }),
    description: attr(),
    category: attr(),
    subcategory: attr(),
    resolver_admin_id: attr({ type: Number }),
    credit_amount: attr(),
    trigger_email: attr(),
    resend_email: attr(),
    resolved_at: attr(),
    created_at: attr(),
    state: attr(),
    creator_gid: attr({ type: String }),
  },
  methods: {
    isResolved() {
      return this.state === 'resolved';
    },
    type() {
      if (this.recipe_id || this.component_ids.length > 0) return 'Recipes';
      if (this.product_ids.length > 0) return 'Products';
      return 'Other';
    },
  },
  static: {
    endpoint: '/feedbacks',
    jsonapiType: 'deliveries-feedbacks',
  },
});

export default Feedback;
